import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	container: {
		color: "#FFFFFF",
		maxWidth: "none",
		height: "100%",
		position: "relative",
		paddingBottom: 23,
		overflow: "hidden",
		"& .mco-extension-component-contact__item + .mco-extension-component-contact__item": {
			borderTop: "1px solid #707070",
			marginTop: 10,
			paddingTop: 10,
			textAlign: "center",
			[theme.breakpoints.up("md")]: {
				textAlign: "right"
			}
		},
		[theme.breakpoints.up("lg")]: {
			display: "flex",
			flexWrap: "wrap",
			paddingBottom: 30,
			"& .mco-extension-component-contact__item + .mco-extension-component-contact__item": {
				borderLeft: "1px solid #707070",
				borderTop: "0",
				marginTop: 0,
				paddingTop: 0
			},
			"& .mco-extension-component-contact__item": {
				position: "relative"
			},
			"& .mco-extension-component-contact__item:after": {
				background: "url('/img/vcard-kitzbuehel.svg') no-repeat center / contain",
				content: "''",
				right: 75,
				width: 100,
				height: 100,
				position: "absolute",
				top: 20
			},
			"& .mco-extension-component-contact__item:last-child:after": {
				backgroundImage: "url('/img/vcard-hollersbach.svg')",
				left: 118,
				right: "auto"
			}
		},
		"@media all and (min-width: 1700px)": {
			"& .mco-extension-component-contact__item:after": {
				width: 130,
				height: 130,
				right: 115
			}
		}
	},
	headline: {
		fontSize: 35,
		fontWeight: 400,
		textAlign: "center",
		margin: "20px 0 10px",
		width: "100%",
		[theme.breakpoints.up("lg")]: {
			fontSize: 55
		}
	}
}));

export default styles;
